// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"af9c67df","455":"2883aafe","977":"c785080f"}[chunkId] + ".chunk.js";
};